import { html } from 'lit';
const Title =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.84 5.25a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0V6.75H7v10.5H5.023a.75.75 0 0 0 0 1.5h5.454a.75.75 0 0 0 0-1.5H8.5V6.75h3.409V8a.75.75 0 0 0 1.5 0V6a.75.75 0 0 0-.75-.75H2.841m12.764 0a.75.75 0 0 0 0 1.5h5.455a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h5.455a.75.75 0 0 1 0 1.5h-5.455a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h5.455a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
export default Title;
